import React from "react";
import { Button, Form, Header, Input } from "semantic-ui-react";

import { RootState } from "../../store/SrciStore";
import { loadConsumerPrefill, save } from "../../store/reducers/SrciInputData";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import ArrayToUiList from "../../helpers/ArrayToUIList";

export default function Customer(this: any) {

  const billingAddress = useAppSelector((state: RootState) => state.srciInputData.billingAddress)
  const consumer = useAppSelector((state: RootState) => state.srciInputData.dcfCheckoutParams.consumer)
  const dcfCheckoutParams = useAppSelector((state: RootState) => state.srciInputData.dcfCheckoutParams)
  const dispatch = useAppDispatch()

  const handleEmailChange = (e: any, element: any) => {
    if(dcfCheckoutParams.consumer.consumerIdentity.identityType === "EMAIL_ADDRESS") {      
      dispatch(save({
        name: "dcfCheckoutParams.consumer.consumerIdentity.identityValue",
        value: element.value
      }))
    }

    dispatch(save({
      name: "dcfCheckoutParams.consumer.emailAddress",
      value: element.value
    }))
  }
  
  const handlePhoneChange = (e: any, element: any) => {
    if(dcfCheckoutParams.consumer.consumerIdentity.identityType === "MOBILE_PHONE_NUMBER") {
      dispatch(save({
        name: "dcfCheckoutParams.consumer.consumerIdentity.identityValue",
        value: dcfCheckoutParams.consumer.mobileNumber.countryCode +""+ element.value
      }))    
    }

    dispatch(save({
      name: "dcfCheckoutParams.consumer.mobileNumber.phoneNumber",
      value: element.value
    }))    
  }

  const handleOnChange = (e: any, element: any) => {
    dispatch(save({
      name: element.name,
      value: element.value
    }))
  }

  const countryCodes = ArrayToUiList(["GB", "SE", "PL"])
  const consumerCountries = ArrayToUiList([{ key: "EMPTY", text: "- EMPTY -", value: "" }, "GB", "SE", "PL"])

  return (
    <React.Fragment>
      <Form>
        <Header as="h2">Personal data</Header>
        <Form.Field>
          <label>Consumer prefill scenarios</label>
          <Button.Group>
            <Button type="button" onClick={() => dispatch(loadConsumerPrefill("complete"))}>Complete</Button>
            <Button type="button" onClick={() => dispatch(loadConsumerPrefill("partial"))}>Partial</Button>
            <Button type="button" onClick={() => dispatch(loadConsumerPrefill("empty"))}>Empty</Button>
          </Button.Group>
        </Form.Field>
        <Form.Group widths='equal'>
            <Form.Field>
                <label>Email Address</label>
                <Input value={consumer.emailAddress} name="dcfCheckoutParams.consumer.emailAddress" onChange={handleEmailChange} />
            </Form.Field>
            <Form.Field>
                <label>First Name</label>
                <Input value={consumer.firstName} name="dcfCheckoutParams.consumer.firstName" onChange={handleOnChange} />
            </Form.Field>     
            <Form.Field>
                <label>Last Name</label>
                <Input value={consumer.lastName} name="dcfCheckoutParams.consumer.lastName" onChange={handleOnChange} />
            </Form.Field>                                 
        </Form.Group>
        <Form.Group widths='equal'>
            <Form.Field>
                <label>Phone Calling Code</label>
                <Input value={consumer.mobileNumber.countryCode} name="dcfCheckoutParams.consumer.mobileNumber.countryCode" onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
                <label>Phone Number</label>
                <Input value={consumer.mobileNumber.phoneNumber} name="dcfCheckoutParams.consumer.mobileNumber.phoneNumber" onChange={handlePhoneChange} />
            </Form.Field>
            <Form.Select fluid label="Consumer Country" options={consumerCountries} value={consumer.countryCode} name="dcfCheckoutParams.consumer.countryCode" onChange={handleOnChange} />
        </Form.Group>      

        <Header as="h2">Address</Header>  
        <Form.Group widths='equal'>
            <Form.Field>
                <label>Name</label>
                <Input value={billingAddress.name} name="billingAddress.name" onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
                <label>Line 1</label>
                <Input value={billingAddress.line1} name="billingAddress.line1" onChange={handleOnChange} />
            </Form.Field>     
            <Form.Field>
                <label>Line 2</label>
                <Input value={billingAddress.line2} name="billingAddress.line2" onChange={handleOnChange} />
            </Form.Field>          
            <Form.Field>
                <label>Line 3</label>
                <Input value={billingAddress.line3} name="billingAddress.line3" onChange={handleOnChange} />
            </Form.Field>                                             
        </Form.Group>
        <Form.Group widths='equal'>
            <Form.Field>
                <label>City</label>
                <Input value={billingAddress.city} name="billingAddress.city" onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
                <label>State</label>
                <Input value={billingAddress.state} name="billingAddress.state" onChange={handleOnChange} />
            </Form.Field>     
            <Form.Field>
                <label>Zip</label>
                <Input value={billingAddress.zip} name="billingAddress.zip" onChange={handleOnChange} />
            </Form.Field>          
            <Form.Select fluid label="Country Code" options={countryCodes} defaultValue={billingAddress.countryCode} name="billingAddress.countryCode" onChange={handleOnChange} />                                            
        </Form.Group>               
      </Form>
    </React.Fragment>
  );
}
